export default __webpack_public_path__ + "static/media/AstronomyJupiter_03.72635661.png";